import React, {useContext, useEffect, useRef, useState} from "react";
import {DownloadReportModal} from "react-spaceship-web";
import {AppContext, history} from "./AppProvider";
import {Link, useLocation} from "react-router-dom";
import {ProductChartOfAccountManage} from "./ProductChartOfAccount";

export default function Relationship() {
	const parentRef = useRef();
	const [loading, setLoading] = useState(true)
	const [response, setResponse] = useState({
		relationship: [],
		count: 0,
	})
	// const [qs, setQs] = useState(window.Global.getAllQueryStrings())
	const {search} = useLocation()
	const context = useContext(AppContext);

	useEffect(() => {

	}, []);

	const fetch = () => {
		setLoading(true)

		let $parent = window.$(parentRef.current);
		let $form = $parent.find('form');

		$parent.find('#download-excel-button').off('click').on('click', () => {
			let data = $form.serializeObject()
			data.is_download_excel = 1;
			window.Global.reactToDom(
				window.$('body'),
				<DownloadReportModal
					url={process.env.REACT_APP_DOMAIN + '/api/relationship'}
					data={data}
				/>
			);
		});

		let object = window.Global.getAllQueryStrings();

		if (context.app.user.user_permission.is_role_audit) {
			object.request_data_product_chart_of_account = 1;
		}

		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/relationship',
			data: object,
			done: (response) => {
				setResponse(response)
				setLoading(false)
			}
		});
	}

	useEffect(() => {
		if (loading) {
			return
		}

		let $Filter_root = window.$(parentRef.current).find('.Filter_root');

		window.Search.init({
			$node: window.$(parentRef.current).find('#Search_root'),
			onSubmit: (data) => {
				history.push(window.Global.getQueryStringLinkFromObject({
					...$Filter_root.serializeObject(),
					...data
				}));
				return false;
			}
		});

		window.$(parentRef.current).find('.Table_root').tablePagination({
			disableContent: true,
			data: response.relationship,
			count: response.count,
			onClickPagination: (p) => {
				let qs = window.Global.getAllQueryStrings();
				qs.page = p;
				history.push(window.Global.getQueryStringLinkFromObject(qs));
			}
		});

		let qs = window.Global.getAllQueryStrings();
		// if (!qs['is_customer']) {
		// 	$Filter_root.find('input[name="is_customer"]').parent().checkbox('set unchecked');
		// }
		// if (!qs['is_supplier']) {
		// 	$Filter_root.find('input[name="is_supplier"]').parent().checkbox('set unchecked');
		// }
		if ((!qs['is_customer'] && !qs['is_supplier']) || (qs['is_customer'] === 'false' && qs['is_supplier'] === 'false')) {
			$Filter_root.find('input[name="is_customer"]').parent().checkbox('set checked');
			$Filter_root.find('input[name="is_supplier"]').parent().checkbox('set checked');
		}

		window.$(parentRef.current).find('form').form2('init', {
			data: qs,
		})
		window.$(parentRef.current).find('form').form2('setup', {
			'start_date_created_onChange': function () {
				setTimeout(function () {
					let link = window.Global.getQueryStringLinkFromObject($Filter_root.serializeObject());
					history.push(link)
				}, 1000);
			},
			'end_date_created_onChange': function () {
				setTimeout(function () {
					let link = window.Global.getQueryStringLinkFromObject($Filter_root.serializeObject());
					history.push(link)
				}, 1000);
			}
		});

		setTimeout(() => {
			if (window.$(parentRef.current).find('.Explorer[data-explorer_input_name="relationship_group_id"]').length === 0) {
				window.$(parentRef.current).find('input[name="relationship_group_id"]').explorer({
					url: process.env.REACT_APP_DOMAIN + '/api/relationship/group',
					additionalData: {
						limit: 15,
						disable_data_more_information: true
					},
					key: 'relationship_group',
					template: {
						list: (value) => {
							return window.Handlebars.compile('<a class="item">\n\t<b style="color: green;">{{name}}</b>\n</a>')(value);
						},
						selected: {
							display_template: '{{name}}',
							value: 'id',
							placeholder: 'กรองกลุ่มลูกค้า'
						}
					}
				});
			}
			if (response['relationship_group']) {
				window.$(parentRef.current).find('input[name="relationship_group_id"]').explorer('set value', response['relationship_group']);
			}
		}, 100)

		// window.$(parentRef.current).find('form').form2('submit', {
		// 	// url: process.env.REACT_APP_DOMAIN + '/api/v1/document_signature',
		// 	// method: this.props.mode === 'create' ? 'POST' : 'PUT',
		// 	loadingButton: window.$(parentRef.current).find('.button.approve'),
		// 	beforeSent: (data) => {
		// 		let link = window.Global.getQueryStringLinkFromObject(data);
		// 		history.push(link)
		// 		return false;
		// 	},
		// });

		// window.GlobalFunc.onChangeFilter($Filter_root, {
		// 	form2SetupOptions: {
		// 		'start_date_created_onChange': function () {
		// 			setTimeout(function () {
		// 				let link = window.Global.getQueryStringLinkFromObject($Filter_root.serializeObject());
		// 				history.push(link)
		// 			}, 1000);
		// 		},
		// 		'end_date_created_onChange': function () {
		// 			setTimeout(function () {
		// 				let link = window.Global.getQueryStringLinkFromObject($Filter_root.serializeObject());
		// 				history.push(link)
		// 			}, 1000);
		// 		}
		// 	},
		// 	// onChange: (url) => {
		// 	// 	console.log(url);
		// 	// }
		// });
	}, [loading, response]);

	useEffect(() => {
		fetch()
	}, [search]); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div ref={parentRef}
		     className={'main ui container'}>
			<div id="HeaderTop_root" className="flex row wrap center align left content align mb-6">
				<div>
					<div className="flex row center align left content align">
						<h2 className="ui huge breadcrumb">
							<Link id="header" className="active section" to="/v2/relationships">ลูกค้าและเจ้าหนี้</Link>
						</h2>
						<div id="Search_root" className={'ml-6'}>
							<form className="ui form">
								<div className="field flex row mb-0">
									<div className="ui action input">
										<input type="text"
										       name="search_query"
										       placeholder="ค้นหาชื่อ"
										       autoComplete="off"
										/>
										<button className="ui icon button"
										        type="submit">
											<i className="search icon"></i>
										</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
				<div className="right floated">
					{
						context.app.user['permission_relationship'] === "read_write"
						&&
						<a id="addRelationshipButton"
						   href="/relationships/new"
						   className="ui positive button">
							เพิ่ม
						</a>
					}
				</div>
			</div>
			<div id="Relationship_root">
				<div className="flex flex-row flex-wrap lg:flex-nowrap">
					<div className={'w-full shrink'}>
						<div id="RelationshipTable_root"
						     className="ui basic table can click Table_root"
						     style={{margin: 0}}
						>
							<div className="thead">
								<div className="tr">
									<div className="th span4">ชื่อ/ประเภท</div>
									<div className="th span3">รหัสคู่ค้า</div>
									<div className="th span3">โทร/อีเมล์</div>
									<div className="th span3">เลขประจำตัวผู้เสียภาษี</div>
									<div className="th span4">ที่อยู่</div>
								</div>
							</div>
							<div className="tbody">
								{
									loading
									&&
									<div className="tr">
										<div className="td center aligned" data-info="nodata">
											<div className="ui active centered inline small loader"></div>
										</div>
									</div>
								}
								{
									!loading
									&& response.relationship.length === 0
									&&
									<div className="tr">
										<div className="td center aligned" data-info="nodata">
											ไม่พบข้อมูล
										</div>
									</div>
								}
								{
									!loading
									&& response.relationship.length !== 0
									&&
									response.relationship.map((relationship, index) => {
										relationship.phone2 = () => {
											if (!relationship.phone) return '-';
											return relationship.phone.join(', ');
										}

										return (
											<a data-no_navigo="true"
											   className='tr'
											   key={window.Global.getRandomInt(1, 1000000)}
											   href={'/relationships?id=' + relationship.id}
											>
												<div className='td span4'>
													<div>
														<div className='flex row middle-xs'>
															<div className={'shrink-0'}>
																<img className="ui image w-[50px]"
																     alt={relationship.name}
																     src={relationship.relationship_image_file_upload.url}
																/>
															</div>
															<div className={'ml-4'}>
																<b>{relationship.name}</b>
																<br/>
																<span className={'opacity-60'}>
																{
																	relationship.is_company === 1
																		? 'นิติบุคคล'
																		: 'บุคคลธรรมดา'
																}
															</span>
															</div>
														</div>
														<div>
															{
																relationship.product_chart_of_account
																&&
																relationship.product_chart_of_account.map((product_chart_of_account, i) => {
																	return (
																		<div key={i}
																		     className={'rounded-md bg-gray-50 p-2 border border-gray-200 hover:bg-gray-100 cursor-pointer flex flex-row wrap mt-1'}
																		     onClick={(e) => {
																			     e.preventDefault()
																			     window.Global.reactToDom(
																				     window.$('body'),
																				     <ProductChartOfAccountManage
																					     mode={'edit'}
																					     relationship={relationship}
																					     product_chart_of_account={product_chart_of_account}
																					     onEdited={(response2) => {
																						     let x = [...response.relationship]
																						     x[index] = response2.relationship
																						     setResponse(prevState => ({
																							     ...prevState,
																							     relationship: x,
																						     }))
																					     }}
																					     onDeleted={(response2) => {
																						     let x = [...response.relationship]
																						     x[index] = response2.relationship
																						     setResponse(prevState => ({
																							     ...prevState,
																							     relationship: x,
																						     }))
																					     }}
																				     />
																			     );
																		     }}
																		>
																			<div className={'mr-2'}>
																				<div>
																					{product_chart_of_account.event2}
																				</div>
																				{
																					product_chart_of_account.is_vat
																						?
																						<div
																							className={'inline-flex rounded bg-green-500 text-white p-0.5 text-xs'}>vat</div>
																						: null
																				}
																			</div>
																			<div className={''}>
																				<b>{product_chart_of_account.code}</b> : {product_chart_of_account.title}
																			</div>
																		</div>
																	)
																})}

															<div
																className={'inline-flex rounded-md bg-gray-50 p-2 text-xs border border-gray-200 hover:bg-gray-100 cursor-pointer mt-1'}
																onClick={(e) => {
																	e.preventDefault()
																	window.Global.reactToDom(
																		window.$('body'),
																		<ProductChartOfAccountManage
																			mode={'create'}
																			relationship={relationship}
																			product_chart_of_account={{
																				is_vat: 2,
																				event: 'relationship_for_overdue',
																				relationship_id: relationship.id,
																			}}
																			onCreated={(response2) => {
																				let x = [...response.relationship]
																				x[index] = response2.relationship
																				setResponse(prevState => ({
																					...prevState,
																					relationship: x,
																				}))
																			}}
																		/>
																	);
																}}
															>เพิ่มบันทึกบัญชี
															</div>
														</div>
													</div>
												</div>
												<div className='td span3'>{relationship.code}</div>
												<div className='td span3'>
													{relationship.phone2()}
													<br/>
													{relationship.email2}
												</div>
												<div className='td span3'>{relationship.tax_number}</div>
												<div className='td span4'>{relationship.print_address}</div>
											</a>
										)
									})
								}
							</div>
						</div>
					</div>
					<form className="ui form Filter_root lg:w-[50%] w-full lg:pl-5 p-0"
					      key={search}
					      autoComplete="off">
						<div className="FilterSection_root mt-0">
							<div className="flex row text-[1.1em] font-bold mb-2">
								<div><i className="ui filter icon"></i>ค้นหา/ตัวกรอง</div>
								<Link to={'/v2/relationships'}
								      className="right floated cursor-pointer text-[#0094fb]">ล้าง</Link>
							</div>
							<div className="ui divider"></div>
							<div className="field">
								<label htmlFor="">จำนวนรายชื่อ</label>
								<h2 id="count-relationship" className={'text-green-600 text-2xl font-bold mb-2'}>
									{
										response
										&& response.count
										&&
										response.count.format()
									}
								</h2>
							</div>
							<div className="flex row padded wrap two column computer" style={{padding: 0}}>
								<div className={'column'}>
									<div className="column field">
										<select className="ui dropdown" name="is_company" data-form2_setup="true">
											<option value="all">ทั้งหมด</option>
											<option value="1">นิติบุคคล</option>
											<option value="0">บุคคลธรรมดา</option>
										</select>
									</div>
									<div className="flex row field">
										<input type="text" name="code" placeholder="รหัสคู่ค้า"/>
									</div>
									<div className="field">
										<input type="text" name="tax_number" placeholder="เลขประจำตัวผู้เสียภาษี"/>
									</div>
									<div className="flex field">
										<input type="text"
										       name="relationship_group_id"
										       autoComplete="off"
										/>
									</div>

									<div className="field">
										<input type="text" name="address_street" placeholder="ที่อยู่" className={'mt-0'}/>
									</div>
									<div className="flex row two field">
										<div>
											<input type="text" name="address_district" placeholder="ตำบล"/>
										</div>
										<div className={'ml-[0.8em]'}>
											<input type="text" name="address_city" placeholder="อำเภอ"/>
										</div>
									</div>
									<div className="flex row two field">
										<div>
											<input type="text" name="address_province" placeholder="จังหวัด"/>
										</div>
										<div className={'ml-[0.8em]'}>
											<input type="text" name="address_zip_code" placeholder="รหัสไปรษณีย์"/>
										</div>
									</div>
									<div className="flex row field">
										<div className="ui checkbox full width shrink">
											<input id="is_customer"
											       type="checkbox"
											       tabIndex="0"
											       className="hidden"
											       name="is_customer"
												// defaultChecked={true}
											/>
											<label htmlFor="is_customer">ลูกหนี้</label>
										</div>
										<div className="ui checkbox full width shrink ml-[1em]">
											<input id="is_supplier"
											       type="checkbox"
											       tabIndex="0"
											       className="hidden"
											       name="is_supplier"
												// defaultChecked={true}
											/>
											<label htmlFor="is_supplier">เจ้าหนี้</label>
										</div>
									</div>
									<div className="flex row field">
										<div className="ui checkbox full width shrink">
											<input id="is_logistic"
											       type="checkbox"
											       tabIndex="0"
											       className="hidden"
											       name="is_logistic"
											/>
											<label htmlFor="is_logistic">เป็นกิจการเกี่ยวกับการขนส่ง</label>
										</div>
									</div>
								</div>
								<div className={'column'}>
									<div className="flex row two fields">
										<div className={'field'}>
											<input type="text" name="facebook" placeholder="Facebook"/>
										</div>
										<div className={'field'}>
											<input type="text" name="line" placeholder="Line" className={'ml-[0.8em]'}/>
										</div>
									</div>

									<div className="flex row two fields">
										<div className={'field'}>
											<input type="text" name="phone" placeholder="โทรศัพท์" autoComplete="off"/>
										</div>
										<div className={'field'}>
											<input type="text" name="fax" placeholder="โทรสาร" className={'ml-[0.8em]'}/>
										</div>
									</div>
									<div className="flex row two fields">
										<div className={'field'}>
											<input type="text" name="email" placeholder="อีเมล์" autoComplete="off"/>
										</div>
										<div className={'field'}>
											<input type="text" name="website" placeholder="เว็บไซต์" className={'ml-[0.8em]'}/>
										</div>
									</div>

									<div className="flex row field">
										<input type="text" name="tag" placeholder="Tags"/>
									</div>
									<div className="column field">
										<label htmlFor="">ช่วงวันที่สร้าง</label>
										<div className="field">
											<div data-form_calendar="date"
											     data-input_name="start_date_created"
											     data-placeholder="ช่วงวันที่สร้าง"
											     data-locale="th"
											     data-initialdate=""
											/>
										</div>
									</div>
									<div className="column field">
										<label htmlFor="">ถึงวันที่สร้าง</label>
										<div className="field">
											<div data-form_calendar="date"
											     data-input_name="end_date_created"
											     data-placeholder="ถึงวันที่สร้าง"
											     data-locale="th"
											     data-initialdate=""></div>
										</div>
									</div>

									<h4 className="ui header dividing">E-Commerce</h4>

									<div className="column field">
										<input type="text"
										       name="relationship_account_username"
										       placeholder="ชื่อบัญชีผู้ใช้งาน"
										       autoComplete="off"
										/>
									</div>
									<div className="column field">
										<input type="text"
										       name="relationship_account_email"
										       placeholder="อีเมล์"
										       autoComplete="off"
										/>
									</div>
									<div className="column field">
										<input type="text"
										       name="relationship_account_phone_number"
										       placeholder="เบอร์โทรศัพท์"
										       autoComplete="off"
										/>
									</div>
									<div className="column flex row field">
										<div className="ui checkbox full width shrink">
											<input id="for_not_use_relationship_account"
											       type="checkbox"
											       tabIndex="0"
											       className="hidden"
											       name="for_not_use_relationship_account"
											/>
											<label htmlFor="for_not_use_relationship_account">ไม่เคยใช้ E-Commerce</label>
										</div>
									</div>
								</div>
							</div>
							<div className="ui divider"></div>
							<div className={'column'}>
								<button className="ui positive button w-full" type="submit">ค้นหา</button>
							</div>
							<div className="column field">
								<div id="download-excel-button" className="link mt-4">Download รายชื่อ</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	)
}
